import { days, diffDays, fmtDate, INTERVIEW_STAGES, WAIT_STAGES, whenText } from '@jt/core';
import type { ApplicationFull } from '@jt/shared';
import { useTodayDate } from '../api/hooks';
import { useUI } from '../components/overlays';
import { Icon } from '../components/ui';
import { openPaste } from '../drafts/openPaste';
import { useAi, useOpenDraft, type DraftKind } from '../drafts/useDraft';
import { useOpenPrep } from '../prep/PrepSheet';

/** Подсказка по ситуации (как assistant() в прототипе). Только при доступном Claude. */
export function Assistant({ a }: { a: ApplicationFull }) {
  const ai = useAi();
  const ui = useUI();
  const today = useTodayDate();
  const openDraft = useOpenDraft();
  const openPrep = useOpenPrep();
  if (!ai) return null;
  const b = (k: DraftKind, t: string) => (
    <button key={k} className="btn sm" onClick={() => openDraft(a.id, k)}>
      {t} <Icon name="chevR" size={14} />
    </button>
  );
  let txt: string;
  let btns;
  if (a.stage === 'saved') {
    txt =
      'Перед откликом: Claude оценит, подходит ли вакансия, и подготовит резюме и письмо под неё — только из фактов вашего профиля.';
    btns = (
      <button className="btn sm" onClick={() => openPrep(a.id)}>
        Подготовить отклик <Icon name="chevR" size={14} />
      </button>
    );
  } else if (INTERVIEW_STAGES.includes(a.stage)) {
    txt = `${a.nextStep ? `${a.nextStep}${a.nextDate ? ' — ' + whenText(a.nextDate, a.nextTime, today).toLowerCase() : ''}. ` : ''}Подготовьте 3 примера из опыта, вопросы команде и повторите темы по стеку вакансии.`;
    btns = b('prep', 'План подготовки');
  } else if (a.stage === 'offer') {
    txt = `${a.score.value != null ? `Совпадение с вашими критериями: ${a.score.value} из 100. ` : ''}${a.offer?.deadline ? `Ответить до ${fmtDate(a.offer.deadline)}. ` : ''}Сравните с другими предложениями и подготовьте ответ.`;
    btns = [b('accept', 'Принять'), b('negotiate', 'Торговаться')];
  } else if (a.stage === 'rejected') {
    txt = 'Попросите короткую обратную связь — она помогает на следующих интервью.';
    btns = b('feedback', 'Попросить обратную связь');
  } else if (a.needsReply) {
    txt = 'Компания ждёт ответа. Claude подготовит черновик с учётом истории переписки.';
    btns = b('reply', 'Ответить');
  } else if (a.stage === 'applied' || WAIT_STAGES.includes(a.stage)) {
    const idle = diffDays(a.lastActivityOn, today);
    txt =
      idle >= 5
        ? `${days(idle)} без ответа — можно коротко напомнить о себе.`
        : 'Вставьте ответ компании, когда он придёт, — Claude обновит статус и контакты.';
    btns =
      idle >= 5 ? (
        b('followup', 'Напомнить о себе')
      ) : (
        <button className="btn sm" onClick={() => openPaste(ui, a.id, a.company)}>
          Разобрать сообщение <Icon name="chevR" size={14} />
        </button>
      );
  } else return null;
  return (
    <div className="assist">
      <div className="ah">
        <Icon name="sparkles" /> Помощник
      </div>
      <p>{txt}</p>
      <div className="btnrow">{btns}</div>
    </div>
  );
}
